import textServices from 'services/text-services'
import { useSession } from 'contexts/session-context'
import Button from 'components/button'
import * as htmlToImage from 'html-to-image';
import { ContainerCard, IdCard, ImgCard, SwitchCard, TitleCard } from './styles'

const Identification = () => {

  const [{ user }] = useSession()

  const handleDownload = () => {
    const element = document.getElementById('my-id-card');
    htmlToImage.toPng(element)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'mi-id.png';
        link.href = dataUrl;
        link.click();
      });
  }

  return (
    <div className="font-bold text-2xl py-7 flex-1 flex flex-col break-all">
      <div className='flex-1 flex flex-col items-center py-12'>
        <ContainerCard className='w-48 h-64 py-2 pb-6 rounded-xl flex flex-col items-center gap-2 bg-no-repeat bg-cover bg-center' id='my-id-card'>
          <SwitchCard className='mx-auto w-9 h-2 rounded-full' />
          <ImgCard alt='Card Icon' src={`${AZURE_BASE_URL}/card-id.png`} className='flex-1' />
          <TitleCard>{textServices.findByText('profile/identification/title', 'MI ID')}</TitleCard>
          <IdCard>#{user?.id}</IdCard>
        </ContainerCard>
      </div>
      <div className='px-10'>
        <Button
          className={`mixx-button ${!window.navigator.share ? 'col-span-2' : ''}`}
          onClick={handleDownload}
        >
          {textServices.findByText('profile/identification/button', 'DESCARGAR MI ID')}
        </Button>
      </div>
    </div>
  )
}

export default Identification